/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory } from './CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory';
import {
    CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryFromJSON,
    CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryFromJSONTyped,
    CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryToJSON,
    CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryToJSONTyped,
} from './CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory';

/**
 * 
 * @export
 * @interface CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest
 */
export interface CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest {
    /**
     * 
     * @type {CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory}
     * @memberof CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest
     */
    fromCategory: CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory;
    /**
     * 
     * @type {CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory}
     * @memberof CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest
     */
    toCategory: CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategory;
}

/**
 * Check if a given object implements the CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest interface.
 */
export function instanceOfCatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest(value: object): value is CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest {
    if (!('fromCategory' in value) || value['fromCategory'] === undefined) return false;
    if (!('toCategory' in value) || value['toCategory'] === undefined) return false;
    return true;
}

export function CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromJSON(json: any): CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest {
    return CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromJSONTyped(json, false);
}

export function CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fromCategory': CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryFromJSON(json['fromCategory']),
        'toCategory': CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryFromJSON(json['toCategory']),
    };
}

export function CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestToJSON(json: any): CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest {
    return CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestToJSONTyped(json, false);
}

export function CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestToJSONTyped(value?: CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fromCategory': CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryToJSON(value['fromCategory']),
        'toCategory': CatalogsOrganizationCatalogIdProductsProductIdMoveProductPutRequestFromCategoryToJSON(value['toCategory']),
    };
}

